import { EAST, WEST } from "./images";
import { PannellumComponent } from "./pannellum";
import { BehaviorSubject } from "rxjs";
import "./index.less";
import { take } from "rxjs/operators";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let isDay = urlParams.get("day") !== "false";
let floorId = urlParams.get("floorId") || "";
const yaw = parseFloat(urlParams.get("yaw") || "0");
const pitch = parseFloat(urlParams.get("pitch") || "0");
const startHFov = parseFloat(urlParams.get("hfov") || "0");
console.log(startHFov);
const $isDay = new BehaviorSubject(isDay);

let active: HTMLButtonElement = null;

window.addEventListener("load", () => {
  const building = document.querySelector<HTMLInputElement>("#building").value;
  const floor = document.querySelector<HTMLDivElement>(".floor-container");
  const maps = building === "east" ? EAST : WEST;
  const pannellum = new PannellumComponent();
  const scenes: Record<string, any> = {};

  const dayToggle = document.querySelector<HTMLInputElement>("#day-toggle");
  const buildingToggle =
    document.querySelector<HTMLInputElement>("#building-toggle");

  Object.keys(maps).forEach((key) =>
    Object.keys(maps[key]).forEach((k, i) => {
      scenes[key + "_" + k] = {
        type: "equirectangular",
        panorama: maps[key][k],
      };
      if (key === "day") {
        const btn = document.createElement("button");
        btn.className = "menu";
        if (i === 0 && !floorId) {
          floorId = k;
          active = btn;
          btn.className += " active";
        } else if (floorId === k) {
          active = btn;
          btn.className += " active";
        }
        btn.id = k;
        btn.innerHTML = k;
        floor.insertBefore(btn, floor.firstChild);
        btn.addEventListener("click", (e) => {
          dayToggle.disabled = true;
          buildingToggle.disabled = true;
          if (active) {
            active.classList.remove("active");
          }
          active = e.target as HTMLButtonElement;
          active.classList.add("active");
          floorId = k;
          window.history.replaceState(
            null,
            null,
            "?floorId=" +
              floorId +
              "&day=" +
              isDay +
              "&yaw=" +
              pannellum.viewer.getYaw() +
              "&pitch=" +
              pannellum.viewer.getPitch()
          );
          pannellum.changeScene((isDay ? "day_" : "night_") + k);
        });
      }
    })
  );

  dayToggle.checked = !isDay;
  dayToggle.onchange = (e) => {
    dayToggle.disabled = true;
    buildingToggle.disabled = true;
    $isDay.next(!(e.target as HTMLInputElement).checked);
  };

  buildingToggle.checked = building === "east";
  buildingToggle.onchange = () => {
    dayToggle.disabled = true;
    buildingToggle.disabled = true;
    window.location.href =
      (building === "east" ? "west-building.html" : "east-building.html") +
      window.location.search +
      "&hfov=" +
      pannellum.viewer.getHfov();
  };

  pannellum.start({
    default: {
      autoLoad: true,
      compass: false,
      showControls: false,
      firstScene: floorId,
      hotSpotDebug: false,
      pitch: pitch,
      yaw: yaw,
      sceneFadeDuration: 1000,
    },
    scenes,
  });

  $isDay.asObservable().subscribe((day) => {
    isDay = day;
    if (floorId) {
      window.history.replaceState(
        null,
        null,
        "?floorId=" +
          floorId +
          "&day=" +
          isDay +
          "&yaw=" +
          pannellum.viewer.getYaw() +
          "&pitch=" +
          pannellum.viewer.getPitch()
      );
      pannellum.changeScene((isDay ? "day_" : "night_") + floorId);
    }
  });

  pannellum.$yaw.asObservable().subscribe((yaw) => {
    if (floorId) {
      window.history.replaceState(
        null,
        null,
        "?floorId=" +
          floorId +
          "&day=" +
          isDay +
          "&yaw=" +
          yaw +
          "&pitch=" +
          pannellum.viewer.getPitch()
      );
    }
  });

  pannellum.$pitch.asObservable().subscribe((pitch) => {
    if (floorId) {
      window.history.replaceState(
        null,
        null,
        "?floorId=" +
          floorId +
          "&day=" +
          isDay +
          "&yaw=" +
          pannellum.viewer.getYaw() +
          "&pitch=" +
          pitch
      );
    }
  });

  if (startHFov) {
    pannellum
      .onLoad()
      .pipe(take(1))
      .subscribe(() => {
        pannellum.viewer.setHfov(startHFov, 0);
      });
  }

  pannellum.onLoad().subscribe(() => {
    dayToggle.disabled = false;
    buildingToggle.disabled = false;
  });
});
